import { SingleCard } from '@liveauctioneers/hammer-ui-core/card/singleCard';
import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { ARTICLE_LINK_CARD_WIDTH_CLASS, ArticleLinkCard } from '@/components/ArticleLinkCard/ArticleLinkCard';
import { useAppSelector } from '@/redux/hooks';
import { getArticleLinks } from '@/redux/modules/articleLinks/articleLinks.selectors';
import { useGuideArticlesExperiment } from '@/utils/amplitude/experiments/hooks/useGuideArticles.experiment';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const ArticleLinksSection = ({ className }: { className?: string }) => {
    const isTreatment = useGuideArticlesExperiment();
    const links = useAppSelector(getArticleLinks);
    const formatMessage = useAppFormatMessage();

    if (!isTreatment || links.length === 0) {
        return null;
    }

    const cards = links.map((link) => ({
        card: (
            <SingleCard
                card={ArticleLinkCard}
                className={ARTICLE_LINK_CARD_WIDTH_CLASS}
                data={link}
            />
        ),
        key: `related-article-${link.id}`,
    }));

    return (
        <div className={cn('mt-xl flex smMax:mt-2xl', className)}>
            <Carousel
                useOverlayControls
                cards={cards}
                title={formatMessage(['SEO', 'articleLinks', 'title'])}
            />
        </div>
    );
};
